import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Page Components
import ThankYou from "../pages/ThankYou.js";
import ConversationMaster from "../pages/ConversationMaster.js";
import LoginFormNew from "../pages/LoginFormNew.js";

// Store and Hooks
import { useBoundStore } from "../store/UseBoundStore1.js";

const AppRoutes = () => {
  const { isLoggedIn, version } = useBoundStore();

  return (
    <Routes>
      <Route
        path=""
        element={
          isLoggedIn ? <Navigate to="/botUserInteraction" /> : <LoginFormNew />
        }
      />
      <Route
        path="/l/:referenceId"
        element={
          isLoggedIn ? <Navigate to="/botUserInteraction" /> : <LoginFormNew />
        }
      />

      <Route
        path="/botUserInteraction"
        element={
          isLoggedIn ? (
            version === "v3" ? (
              <ConversationMaster />
            ) : (
              <Navigate to="/" />
            )
          ) : (
            <Navigate to="/" />
          )
        }
      />
      {/* Protected Routes */}
      <Route
        path="/thankyou"
        element={isLoggedIn ? <ThankYou /> : <Navigate to="/" />}
      />
    </Routes>
  );
};

export default AppRoutes;
